// /home/ladmin/ESTATA/apps/0001-estata.com/frontend/src/pages/DueDiligence.tsx


import HeroParallax from "../../components/HeroParallax.tsx";
import Counter from "../../components/Counter.tsx";
import Showcase from "../../components/Showcase.tsx";
import PartnerGrid from "../../components/PartnerGrid.tsx";
import CareersBanner from "../../components/CareersBanner.tsx";
import ESG from "../../components/ContentCard.tsx";
import ContactPerson from "../../components/ContactPerson.tsx";
import AnchorMenu from "../../components/AnchorMenu.tsx";
import { useLanguage } from "../../lang/index.lang.tsx";

const DueDiligence = () => {
  const { t } = useLanguage();

  return (
    <>
      <AnchorMenu
        title={t("services.due-diligence.title")}
        titleLink="#services"
        items={[
          { id: "Title", label: t("counter.heading.title"), anchor: "Counter" },
          { id: "2", label: t("anchor.whatWeDo"), anchor: "AllServices" },
          { id: "3", label: t("navigation.career"), anchor: "Careers" },
          { id: "4", label: t("services.heading.partner"), anchor: "Partner" },
          { id: "5", label: t("anchor.contactPersons"), anchor: "ContactPersons" },
          { id: "6", label: t("home.esg.heading.subtitle"), anchor: "esg" },
        ]}
      />
    <section id="Services">
      <HeroParallax        
        header={t("services.due-diligence.header")}
        welcome={t("services.due-diligence.welcome")}
        title={t("services.due-diligence.description.short")}
        description={t("services.due-diligence.description.long")}
        buttonText={t("common.learnMore")}
        buttonLink=""
        image="/images/EST-767664.jpg"
      />
    </section>

      
       
      

      <section id="Counter">
        <Counter
          items={[
            {
              key: "transactionVolume",
              endValue: 12,
              prefix: "",
              suffix: " Mrd. €+",
            },
            {
              key: "transactionCount",
              endValue: 1000,
              prefix: "",
              suffix: "+",
            },
            {
              key: "industriesServed",
              endValue: 10,
              prefix: "",
              suffix: "+",
            },
            {
              key: "transactionSquareMeters",
              endValue: 2,
              prefix: "",
              suffix: " Mio.+",
            },
          ]}
          sectionTitle={t("services.due-diligence.title")}
          mainTitle={t("counter.heading.title")}
        />
      </section>

      <section id="AllServices">
        <Showcase
          heading={{
            subtitle: t("services.due-diligence.title"),
            title: t("services.due-diligence.header"),
            explore: t("services.due-diligence.explore"),
          }}
          items={[
            {
              id: 1,
              title: t("services.red-flag-services.title"),
              subtitle: t("services.red-flag-services.description.short"),
              description: t("services.red-flag-services.description.long"),
              link: "",
            },
            {
              id: 2,
              title: t("services.technical-due-diligence.title"),
              subtitle: t("services.technical-due-diligence.description.short"),
              description: t("services.technical-due-diligence.description.long"),
              link: "",
            },            
            {
              id: 3,
              title: t("services.environmental-due-diligence.title"),
              subtitle: t("services.environmental-due-diligence.description.short"),
              description: t("services.environmental-due-diligence.description.long"),
              link: "",
            },
            {
              id: 4,
              title: t("services.heating-energy-services.title"),
              subtitle: t("services.heating-energy-services.description.short"),
              description: t("services.heating-energy-services.description.long"),
              link: "",
            },
            {
              id: 5,
              title: t("services.energy-advisory.title"),
              subtitle: t("services.energy-advisory.description.short"),
              description: t("services.energy-advisory.description.long"),
              link: "/services/fire-protection",
            },
          ]}
          learnMoreText={t("services.heading.learnMore")}
        />
      </section>

      <section id="Careers">
        <CareersBanner
          image="/images/EST-6372937.jpg"
          title={t("home.heroBanner.title")}
          description={t("home.heroBanner.description")}
          buttonText={t("home.heroBanner.buttonText")}
          buttonLink="/careers"
        />
      </section>

      <section id="Partner">
        <PartnerGrid />
      </section>

      <section id="ContactPersons">
        <ContactPerson
          heading={{
            subtitle: t("services.due-diligence.department"),
            title: t("services.heading.contact-person"),
          }}
          employeeIds={["AS", "PR", "YS", "AD"]}
        />
      </section>

      <section id="esg">
        <ESG
          heading={{
            title: t("home.esg.heading.title"),
            description: t("home.esg.heading.description"),
          }}
          data={[
            {
              id: 1,
              title: t("home.esg.s.title"),
              description: t("home.esg.s.description"),
              image: "/images/EST-1385648186.jpg",
              category: t("home.esg.s.category"),
              buttonText: t("home.esg.s.buttonText"),
              buttonLink: "/about",
            },
            {
              id: 2,
              title: t("home.esg.e.title"),
              description: t("home.esg.e.description"),
              image: "/images/EST-599972772.jpg",
              category: t("home.esg.e.category"),
              buttonText: t("home.esg.e.buttonText"),
              buttonLink: "/about",
            },
            {
              id: 3,
              title: t("home.esg.g.title"),
              description: t("home.esg.g.description"),
              image: "/images/EST-12499784456.jpg",
              category: t("home.esg.g.category"),
              buttonText: t("home.esg.g.buttonText"),
              buttonLink: "/about",
            },
          ]}
        />
      </section>
    </>
  );
};

export default DueDiligence;
